import http from "./http";

/**
 * Fetch user dashboard data.
 * @param {object} params  – { order_year?, store_year? }
 */
export const getDashboardData = (params = {}) =>
  http.get("/auth/dashboard/", { params });
